import type { FormDto, FormInteractionMode } from "../../types/form";
import type { FormListItemDto } from "../../types/formList";
import { parseBoolean } from "./parseBoolean";

type FormWithClosedState = Pick<
  FormDto,
  "is_closed" | "closed_message" | "isClosed" | "closedMessage"
>;

type FormWithShowSubmission = {
  showSubmissionAfterSubmit?: unknown;
  show_submission_after_submit?: unknown;
};

/** `null`, если поля нет — для PATCH его не отправляем. */
export function readShowSubmissionAfterSubmit(
  source: FormWithShowSubmission | null | undefined,
): boolean | null {
  if (!source) return null;
  if (source.showSubmissionAfterSubmit != null) {
    return parseBoolean(source.showSubmissionAfterSubmit);
  }
  if (source.show_submission_after_submit != null) {
    return parseBoolean(source.show_submission_after_submit);
  }
  return null;
}

export function isShowSubmissionAfterSubmit(
  form: FormWithShowSubmission | null | undefined,
): boolean {
  return readShowSubmissionAfterSubmit(form) === true;
}

type FormWithInteractionMode = {
  interactionMode?: unknown;
  interaction_mode?: unknown;
};

/** `null`, если поля нет — для PATCH его не отправляем. */
export function readInteractionMode(
  source: FormWithInteractionMode | null | undefined,
): FormInteractionMode | null {
  if (!source) return null;
  const raw =
    source.interactionMode != null
      ? source.interactionMode
      : source.interaction_mode;
  if (raw == null || raw === "") return null;
  const value = String(raw).trim().toLowerCase();
  if (value === "chatbot") return "chatbot";
  if (value === "quiz") return "quiz";
  if (value === "form") return "form";
  return null;
}

export function resolveInteractionMode(
  source: FormWithInteractionMode | null | undefined,
): FormInteractionMode {
  return readInteractionMode(source) ?? "form";
}

export function isFormClosed(form: FormWithClosedState): boolean {
  if (form.is_closed != null) return parseBoolean(form.is_closed);
  if (form.isClosed != null) return parseBoolean(form.isClosed);
  return false;
}

export function getFormClosedMessage(
  form: FormWithClosedState,
  fallback = "Форма закрыта",
): string {
  const message = form.closed_message ?? form.closedMessage;
  if (typeof message === "string" && message.trim() !== "") {
    return message.trim();
  }
  return fallback;
}

export function formListCreatedAt(form: FormListItemDto): string | undefined {
  return form.createdAt ?? form.created_at ?? form.updatedAt ?? form.updated_at;
}

export function isFormListItemClosed(form: FormListItemDto): boolean {
  if (form.isClosed != null) return parseBoolean(form.isClosed);
  if (form.is_closed != null) return parseBoolean(form.is_closed);
  return false;
}
